// extracted by mini-css-extract-plugin
export var dark = "v_s1";
export var darkcookie = "v_s2";
export var tintedcookie = "v_s3";
export var regularcookie = "v_s4";
export var darkbase = "v_s5";
export var tintedbase = "v_s6";
export var regularbase = "v_s7";
export var darkraw = "v_s8";
export var tintedraw = "v_s9";
export var regularraw = "v_tb";
export var darkchick = "v_tc";
export var tintedchick = "v_td";
export var regularchick = "v_tf";
export var darkherbarium = "v_tg";
export var tintedherbarium = "v_th";
export var regularherbarium = "v_tj";
export var darkholiday = "v_tk";
export var tintedholiday = "v_tl";
export var regularholiday = "v_tm";
export var darkoffline = "v_tn";
export var tintedoffline = "v_tp";
export var regularoffline = "v_tq";
export var darkorchid = "v_tr";
export var tintedorchid = "v_ts";
export var regularorchid = "v_tt";
export var darkpro = "v_tv";
export var tintedpro = "v_tw";
export var regularpro = "v_tx";
export var darkrose = "v_ty";
export var tintedrose = "v_tz";
export var regularrose = "v_tB";
export var darktimes = "v_tC";
export var tintedtimes = "v_tD";
export var regulartimes = "v_tF";
export var darkwagon = "v_tG";
export var tintedwagon = "v_tH";
export var regularwagon = "v_tJ";